module.exports = __webpack_public_path__ + "img/ice5.2134f707.png";